let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2AL0H")).then(() => parcelRequire('5vTPX'));